import { useRecoilValue, useSetRecoilState } from "recoil";
import { loginState } from "../../stores/loginState";
import { useMutation } from "react-query";
import {
  HandexInstance,
  HanjinInstance,
  LogenInstance,
  LotteInstance,
} from "../instance";
import { calendarDataState } from "../../stores/calendar/calendarDataState";

// TODO 월간 데이터 조회 API
const useGetCalenderData = (date) => {
  // NOTE 상태 변수
  const login = useRecoilValue(loginState); // 로그인 전역변수
  const setCalendarData = useSetRecoilState(calendarDataState); // 월간 데이터 전역변수

  // TODO API 결과
  const mutationOptions = {
    // 성공 시
    onSuccess: (data) => {
      if (data.result === "00" || data.result === "77") {
        setCalendarData(data.data);
      }
    },
    // 실패 시
    onError: (error) => {
      console.log(error);
    },
  };

  const [year, month] = date.split("-").slice(0, 2); // 연, 월 변수
  const postData = {
    bran_cd: login.branchCode,
    year: year,
    month: month,
  };

  let mutationFn;

  // TODO API 리퀘스트 정보
  if (login.company === "LOGEN") {
    mutationFn = () => LogenInstance.post("/calendar-data", postData);
  } else if (login.company === "LOTTE") {
    mutationFn = () => LotteInstance.post("/calendar-data", postData);
  } else if (login.company === "HANJIN") {
    mutationFn = () => HanjinInstance.post("/calendar-data", postData);
  } else if (login.company === "HANDEX") {
    mutationFn = () => HandexInstance.post("/calendar-data", postData);
  } else {
    mutationFn = () => {
      throw new Error("Invalid company");
    };
  }

  return useMutation("getAmount", mutationFn, mutationOptions);
};

export default useGetCalenderData;
